module.exports = __webpack_public_path__ + "static/language-selector-mobile-screen@3x-709285851380bba4870653827ea66c76.png";